import Bid from './Bid'
import MaxBid from './MaxBid'
import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../contexts/AuthContext'
import BidButton from '../../elements/BidButton/BidButton'
import { getTimeLeft } from '@components/BiddingButtons/functions'
import LoginRedirect from '@components/LoginRedirect'
import C from '@utilities/constants'

const BiddingButtons = ({
  item,
  updateItem,
  isItemDetail,
  loadingBid,
  setLoadingBid,
  toggleModal,
  setModalAction,
  setModalData,
  location,
}: any) => {
  const [expired, setExpired] = useState<any>(false)
  const {
    isAuthenticated,
    userData: {
      profile: { isAddedCard },
    },
    isLoading,
    isSubscribed,
  } = useContext<any>(AuthContext)
  const { utcEndDateTime } = item

  useEffect(() => {
    const timeLeft = getTimeLeft(utcEndDateTime)
    const startDisabledCountdown = setTimeout(() => {
      if (timeLeft >= 2147483647) return
      setExpired(true)
    }, timeLeft)
    return () => {
      clearTimeout(startDisabledCountdown)
    }
  }, [utcEndDateTime])

  const handleBan = (type: any, isHardBan?: any) => {
    const message = isHardBan
      ? '<p>This account is currently suspended.</p><p>Please contact Customer Support for more information at: <a href="mailto:support@bidfta.com">support@bidfta.com</a>.</p>'
      : '<p>Your account is currently suspended from bidding.</p><p>Please pay all <a href="/account/dashboard/invoices">Open Invoices</a> or contact Customer Support at: <a href="mailto:support@bidfta.com">support@bidfta.com</a>.'
    const modalData = {
      msg: message,
      type: 'Ban',
    }
    toggleModal(true, 'Ban')
    setModalData(modalData)
  }

  if (isLoading) {
    return (
      <div className={'flex flex-col gap-2'}>
        <div />
        <div className={'animate-pulse w-full h-11 bg-slate-400 rounded-md'} />
        <div className={'animate-pulse w-full h-11 bg-slate-200 rounded-md'} />
      </div>
    )
  }

  if (!isAuthenticated) return <LoginRedirect />

  if (!isAddedCard)
    return (
      <BidButton
        label="Add Card To Bid"
        theme="blue-light"
        link="/account/dashboard/cards"
        type="link"
        width="full"
      />
    )

  if (!isSubscribed && (
      item?.auctionTypeId === C.MEMBERS_ONLY_TYPE_ID ||
      item?.itemTypeId === C.MEMBERS_ONLY_TYPE_ID
    ))
    return (
      <BidButton
        label="Subscribe to BidFTA+"
        theme="blue-light"
        link="/bidfta-plus"
        type="link"
        width="full"
      />
    )

  return (
    <div className="flex flex-col gap-4">
      <Bid
        location={location}
        item={item}
        updateItem={updateItem}
        expired={expired}
        loadingBid={loadingBid}
        setLoadingBid={setLoadingBid}
        handleBan={handleBan}
        toggleModal={toggleModal}
        setModalAction={setModalAction}
        setModalData={setModalData}
        isItemDetail={isItemDetail}
      />
      <MaxBid
        item={item}
        updateItem={updateItem}
        expired={expired}
        handleBan={handleBan}
      />
    </div>
  )
}

export default BiddingButtons
